import React from "react";
import { FaShieldAlt, FaBuilding, FaLeaf, FaTint, FaGlobe } from "react-icons/fa";
import Navbar from "../components/Navbar";
import Sidebar from "../components/Sidebar";

// Same content as the mobile app's AboutScreen (source: jainfarms.com).
const SERVICES = [
  { icon: <FaShieldAlt />, color: "#dc2626", title: "24/7 Farmland Security", text: "Round-the-clock security across every gated community." },
  { icon: <FaBuilding />, color: "#d4a017", title: "Clubhouse Maintenance", text: "Well-kept common areas and clubhouse facilities for every member." },
  { icon: <FaLeaf />, color: "#2e7d32", title: "Professional Horticulture Care", text: "A dedicated team of agricultural consultants tends every farm." },
  { icon: <FaTint />, color: "#1e40af", title: "Ready Infrastructure", text: "Every farmhouse comes with water supply and electricity connections." },
];

const LOCATIONS = [
  { name: "Bagalur, Bengaluru", detail: "800+ acres · 130 farmhouses" },
  { name: "Kodaikanal", detail: "150 acres" },
  { name: "Hyderabad", detail: "150 acres" },
  { name: "Jaipur", detail: "150 acres" },
  { name: "Sakleshpur", detail: "50 acres" },
];

function About() {
  return (
    <>
      <Navbar />
      <Sidebar />

      <div className="main-content">
        <div className="visit-card" style={{ marginBottom: "20px", textAlign: "center" }}>
          <h1 style={{ marginBottom: "2px" }}>🌿 Jain Farms</h1>
          <p style={{ color: "#666" }}>A Gated Community of Farmlands</p>
        </div>

        <div className="visit-card" style={{ marginBottom: "20px" }}>
          <p style={{ fontSize: "11px", fontWeight: 800, color: "#888", letterSpacing: "0.6px", margin: "0 0 8px" }}>
            OUR VISION
          </p>
          <p style={{ color: "#555", lineHeight: 1.6 }}>
            Jain Farms is a community driven by the vision of reconnecting people with nature —
            where every individual owns, nurtures, and lives in harmony with the land, restoring
            balance to the planet. We create sustainable, nature-connected living by developing
            gated communities of farmlands and eco-resorts that promote harmony, wellness, and
            green living.
          </p>
        </div>

        <p style={{ fontSize: "11px", fontWeight: 800, color: "#888", letterSpacing: "0.6px", margin: "0 0 10px" }}>
          WHAT WE DO
        </p>
        {SERVICES.map((s) => (
          <div key={s.title} className="visit-card" style={{ marginBottom: "12px", display: "flex", gap: "14px", alignItems: "flex-start" }}>
            <span
              style={{
                width: "44px", height: "44px", borderRadius: "22px", flexShrink: 0, display: "flex",
                alignItems: "center", justifyContent: "center", background: s.color + "22", color: s.color, fontSize: "18px",
              }}
            >
              {s.icon}
            </span>
            <div>
              <div style={{ fontWeight: 700, marginBottom: "2px" }}>{s.title}</div>
              <div style={{ color: "#666", fontSize: "13px" }}>{s.text}</div>
            </div>
          </div>
        ))}
        <p style={{ color: "#777", fontSize: "12px", fontStyle: "italic", margin: "0 0 20px" }}>
          Every project is supported by an empanelled team of architects, agricultural
          consultants, and security specialists, so ownership stays worry-free from design
          to daily upkeep.
        </p>

        <div className="visit-card" style={{ marginBottom: "20px" }}>
          <p style={{ fontSize: "11px", fontWeight: 800, color: "#888", letterSpacing: "0.6px", margin: "0 0 8px" }}>
            OUR LOCATIONS
          </p>
          {LOCATIONS.map((loc, i) => (
            <div
              key={loc.name}
              style={{
                display: "flex", justifyContent: "space-between", padding: "8px 0",
                borderBottom: i < LOCATIONS.length - 1 ? "1px solid #eee" : "none",
              }}
            >
              <span style={{ fontWeight: 600 }}>{loc.name}</span>
              <span style={{ color: "#888", fontSize: "13px" }}>{loc.detail}</span>
            </div>
          ))}
        </div>

        <a
          href="https://jainfarms.com"
          target="_blank"
          rel="noopener noreferrer"
          className="submit-visit-btn"
          style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "8px", textDecoration: "none", maxWidth: "700px" }}
        >
          <FaGlobe /> Visit jainfarms.com
        </a>
      </div>
    </>
  );
}

export default About;
